import { LOCALE } from '@wix/wix-chatbot-common/locale';

import { renderModel } from './renderModel';

const SUPPORTED_LOCALES = [
  LOCALE.EN,
  LOCALE.DE,
  LOCALE.ES,
  LOCALE.FR,
  LOCALE.PT,
  LOCALE.IT,
  LOCALE.NL,
  LOCALE.JA,
  LOCALE.KO,
  LOCALE.TR,
  LOCALE.RU,
];

export const isAnswerGenerationEnabled = (): boolean => {
  const locale = renderModel.getLocale() as LOCALE;
  return SUPPORTED_LOCALES.includes(locale);
};
